import { render, staticRenderFns } from "./ApproveLabelButton.vue?vue&type=template&id=a351757c&"
import script from "./ApproveLabelButton.vue?vue&type=script&lang=js&"
export * from "./ApproveLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports